import React, { useContext } from "react";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillDelete, AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { Link } from "react-router-dom";

const SubTable = ({
  blog,
  allBlogs,
  page,
  sort,
  setSort,
  manager,
}) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const notification = useToastContext();

  const handelDelete = async (item) => {
    try {
      const path = apiPath.deleteBlog + "/" + item?._id;
      const result = await apiPut(path);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allBlogs()
      } else {
        notification.error(result.data.message);
      }
    } catch (error) {
      console.log("error in get all FAQs list==>>>>", error.message);
    }
  };

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.changeStatusBlog}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        allBlogs()
      }
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-2">
                #
              </th>

              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sortKey === "categoryDetails.title" &&
                    sort.sortType === "asc"
                  ) {
                    setSort({
                      sortKey: "categoryDetails.title",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "categoryDetails.title",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_CATEGORY")} </span>
                  <span>
                    {sort.sortKey === "categoryDetails.title" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "categoryDetails.title" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sortKey === "subCategoryDetails.title" &&
                    sort.sortType === "asc"
                  ) {
                    setSort({
                      sortKey: "subCategoryDetails.title",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "subCategoryDetails.title",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_SUBCATEGORIES")} </span>
                  <span>
                    {sort.sortKey === "subCategoryDetails.title" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "subCategoryDetails.title" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sortKey === "authorName" &&
                    sort.sortType === "asc"
                  ) {
                    setSort({
                      sortKey: "authorName",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "authorName",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_AUTHOR_NAME")} </span>
                  <span>
                    {sort.sortKey === "authorName" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "authorName" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer min-w-[250px]"
                onClick={() => {
                  if (sort.sortKey === "title" && sort.sortType === "asc") {
                    setSort({
                      sortKey: "title",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "title",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_TITLE")} </span>
                  <span>
                    {sort.sortKey === "title" && sort.sortType === "asc" && (
                      <BsArrowUpShort className="w-4 h-4" />
                    )}
                    {sort.sortKey === "title" && sort.sortType === "desc" && (
                      <BsArrowUpShort className="w-4 h-4 rotate-180" />
                    )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sortKey === "likes.likesCount" &&
                    sort.sortType === "asc"
                  ) {
                    setSort({
                      sortKey: "likes.likesCount",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "likes.likesCount",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_LIKES")} </span>
                  <span>
                    {sort.sortKey === "likes.likesCount" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "likes.likesCount" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sortKey === "comments.commentsCount" &&
                    sort.sortType === "asc"
                  ) {
                    setSort({
                      sortKey: "comments.commentsCount",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "comments.commentsCount",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_COMMENTS")} </span>
                  <span>
                    {sort.sortKey === "comments.commentsCount" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "comments.commentsCount" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (sort.sortKey === "createdAt" && sort.sortType === "asc") {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_POSTED_DATE")} </span>
                  <span>
                    {sort.sortKey === "createdAt" &&
                      sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sortKey === "createdAt" &&
                      sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              {(manager?.add || user?.role === 'admin') && (
                <th scope='col' className='py-3 px-2 text-center'>
                  {t('O_STATUS')}
                </th>
              )}
              {(manager?.add || user?.role === "admin") && (
                <>
                  <th scope="col" className="py-3 px-2 text-center">
                    {t("O_ACTION")}
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {blog &&
              blog?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-2 px-2 border-r">
                    {item?.categoryDetails?.title}
                  </td>
                  <td className="py-2 px-2 border-r">
                    {item?.subCategoryDetails?.title}
                  </td>
                  <td className="py-2 px-2 border-r">{item?.authorName}</td>
                  <td className="py-2 px-2 border-r">{item?.title}</td>
                  <td className="py-2 px-2 border-r">
                    {item?.likes?.likesCount || 0}
                  </td>
                  <td className="py-2 px-2 border-r">
                    {item?.comments?.commentsCount || 0}
                  </td>
                  <td className="py-2 px-2 border-r">
                    {dayjs(item?.createdAt).format("lll")}
                  </td>
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-2 px-2 border-r text-center'>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        title={`${
                          item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                      >
                        <input
                          type='checkbox'
                          className='sr-only peer'
                          checked={item?.status === 'active'}
                          onChange={e =>
                            helper.alertFunction(
                              `${t('ARE_YOU_SURE')} ${
                                e.target.checked ? t('O_ACTIVE_SMALL') : t('O_INACTIVE_SMALL')
                              } ${item.title}`,
                              item,
                              handelStatusChange
                            )
                          }
                          // onChange={(e) => handelStatusChange(item)(e)}
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                      </label>
                    </td>
                  )}
                  <td className="py-2 px-2 border-l">
                    <div className="">
                      <ul className="flex justify-center">
                      {(manager?.add || user?.role === "admin") && (
                          <Link
                            title="View Blog"
                            className="text-danger ml-2"
                            to="/blogs/View-blog"
                            state={{ ...item }}
                          >
                            <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />
                          </Link>
                        )}
                        {(manager?.add || user?.role === "admin") && (
                          <Link
                            title="Edit Blog"
                            className="text-danger ml-2"
                            to="/blogs/Edit-blog"
                            state={{ ...item }}
                          >
                            <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                          </Link>
                        )}
                        {(manager?.delete || user?.role === "admin") && (
                          <li
                            onClick={(e) =>
                              helper.alertFunction(
                                `${t('ARE_YOU_SURE_TO_DELETE_BLOG')}`,
                                item,
                                handelDelete,
                                true
                              )
                            }
                            // onClick={() => handelDelete(item)}
                            className="px-2 hover:bg-white hover:text-LightBlue"
                          >
                            <a title={t("O_DELETE")}>
                              {" "}
                              <AiFillDelete className="w-5 h-5 text-red-600" />{" "}
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(blog) ? (
              <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-2 px-2" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubTable;
